export default __webpack_public_path__ + "static/media/logoWA.ed8e779d.jpeg";